export enum LengthOption {
    FifteenMinutes = "15min",
    ThirtyMinutes = "30min",
    FortyFiveMinutes = "45min",
    OneHour = "1hour",
    OverTwoHours = "2+hour",
}
